<template>
  <div
    class="d-flex flex-row flex-wrap justify-content-start text-center w-100 icontainer"
    :class="{
      mobile: isMobile,
    }"
  >
    <template v-for="item in menuItems" :key="item.label">
      <router-link
        v-if="item.to && item.visible"
        style="border-radius: 12px; box-shadow: 2px 2px 2px #0003"
        :style="{
          height: isMobile ? '50px' : '75px',
        }"
        :to="item.to"
        class="d-flex flex-row bg-white mb-2 p-3"
      >
        <i
          class="mb-1 me-2"
          :class="{
            [item.icon]: true,
            'icon-sm': isMobile,
            'icon-md': !isMobile,
          }"
        ></i>
        <span
          :style="{
            'font-size': isMobile ? '0.75rem' : '0.85rem',
          }"
          >{{ item.label }}</span
        >
      </router-link>
      <div
        v-if="item.command && item.visible"
        style="border-radius: 12px; box-shadow: 2px 2px 2px #0003"
        :style="{
          height: isMobile ? '50px' : '75px',
        }"
        class="d-flex flex-row bg-white mb-2 p-3"
        role="button"
        @click="item.command"
      >
        <i
          class="mb-1 me-2"
          :class="{
            [item.icon]: true,
            'icon-md': isMobile,
            'icon-lg': !isMobile,
          }"
        ></i>
        <span
          :style="{
            'font-size': isMobile ? '0.75rem' : '0.85rem',
          }"
          >{{ item.label }}</span
        >
      </div>
    </template>
  </div>
</template>

<script setup lang="ts">
import type { MenuItem } from "primevue/menuitem";
import { useMqUtils } from "/@/vue/composables";

defineProps<{
  menuItems: MenuItem[];
}>();

const { isMobile } = useMqUtils();
</script>

<style scoped lang="scss">
.icontainer {
  > * {
    margin-right: 0.5rem;
    width: calc(25% - 0.375rem); // 0.5 * 3 / 4 = 0.375

    &:nth-child(4n) {
      margin-right: 0;
    }
  }

  &.mobile {
    > * {
      width: 100%;
      margin-right: 0;
    }
  }
}
</style>
